/* Lab401 guided finder. Only retained answers go to the server; no browser storage. */
(function () {
  'use strict';
  var API_URL = 'https://lab401-recommend-preview.lab401.workers.dev/api/recommend';
  var MAX_ANSWERS = 8, REQUEST_TIMEOUT = 120000;
  function init(root) {
    if (root.dataset.finderReady) return;
    root.dataset.finderReady = 'true';
    var labels = JSON.parse(root.querySelector('[data-l4r-labels]').textContent);
    var form = root.querySelector('[data-l4r-form]'), input = root.querySelector('[data-l4r-input]');
    var submit = root.querySelector('[data-l4r-btn]'), conversation = root.querySelector('[data-l4r-conversation]');
    var refinement = root.querySelector('[data-l4r-refinement]'), supportBox = root.querySelector('[data-l4r-support]');
    var results = root.querySelector('[data-l4r-results]'), loading = root.querySelector('[data-l4r-loading]');
    var status = root.querySelector('[data-l4r-status]');
    var prefix = (root.dataset.rootUrl || '/').replace(/\/?$/, '/');
    var prompt = '', answers = [], active = null, editing = -1, revision = 0, controller = null;
    var pending = false, lastResponse = null, pendingPayload = null, activeDraft = '';
    var prompts = JSON.parse(root.querySelector('[data-l4r-prompts]').textContent);
    var loadingMessages = JSON.parse(root.querySelector('[data-l4r-loading-msgs]').textContent);
    var loadingText = root.querySelector('[data-l4r-loading-text]');
    var promptIndex = 0, loadingIndex = 0, loadingTimer = null;
    function rotatePrompt() {
      if (!prompts.length || (document.activeElement === input && input.value)) return;
      input.placeholder = prompts[promptIndex++ % prompts.length];
    }
    rotatePrompt();
    var promptTimer = setInterval(rotatePrompt, 3500);
    function startLoadingMessages() {
      if (!loadingMessages.length) return;
      loadingIndex = 0; loadingText.textContent = loadingMessages[0];
      loadingTimer = setInterval(function () {
        loadingText.textContent = loadingMessages[++loadingIndex % loadingMessages.length];
      }, 3000);
    }
    function stopLoadingMessages() { clearInterval(loadingTimer); loadingTimer = null; }

    function node(tag, cls, text) {
      var el = document.createElement(tag); if (cls) el.className = cls;
      if (text !== undefined) el.textContent = text; return el;
    }
    function button(cls, text, action) {
      var el = node('button', cls, text); el.type = 'button'; el.addEventListener('click', action); return el;
    }
    function arrow() {
      var el = node('span', 'l4r__question-arrow', '\u21aa'); el.setAttribute('aria-hidden', 'true'); return el;
    }
    function announce(text) { status.textContent = text; }
    function focusAnswer(select) {
      var field = root.querySelector('textarea:not(:disabled)');
      if (field) { field.focus({ preventScroll: true }); if (select) field.select(); }
    }
    function sizeAnswers() {
      root.querySelectorAll('.l4r__question').forEach(function (row) {
        var label = row.querySelector('.l4r__question-label');
        row.classList.toggle('l4r__question--long', label.getBoundingClientRect().height > 18);
        var field = row.querySelector('textarea');
        field.style.height = '0px'; field.style.height = field.scrollHeight + 'px';
      });
    }
    var conversationWidths = new WeakMap(), resizeFrame = null;
    var sizeObserver = new ResizeObserver(function (entries) {
      var changed = false;
      entries.forEach(function (entry) {
        var width = entry.contentRect.width;
        if (conversationWidths.get(entry.target) !== width) {
          conversationWidths.set(entry.target, width); changed = true;
        }
      });
      if (changed) {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(sizeAnswers);
      }
    });
    sizeObserver.observe(conversation);
    sizeObserver.observe(refinement);
    document.fonts.ready.then(function () { if (root.isConnected) sizeAnswers(); });
    function cancelRequest() {
      revision++; if (controller) controller.abort();
      controller = null; pending = false; loading.hidden = true;
      stopLoadingMessages();
      submit.disabled = false; submit.textContent = labels.search; root.removeAttribute('aria-busy');
    }
    function clearResults() { results.replaceChildren(); supportBox.replaceChildren(); lastResponse = null; }
    function payload() {
      return { version: 2, prompt: prompt, locale: root.dataset.locale || 'en', answers: answers.map(function (a) {
        return { question_id: a.question.id, question: a.question.text, answer: a.answer };
      }) };
    }
    function support() {
      supportBox.replaceChildren();
      var box = node('div', 'l4r__support');
      box.append(node('span', 'l4r__support-title', labels.support_title), node('span', 'l4r__support-text', labels.support_text));
      var link = node('a', 'l4r__support-link', labels.support_cta);
      var transcript = prompt + answers.map(function (a) { return '\n' + a.question.text + '\n' + a.answer; }).join('');
      link.href = prefix + 'pages/contact-support?subject=' + encodeURIComponent(labels.support_subject) + '&body=' + encodeURIComponent(labels.support_body + transcript);
      box.append(link); supportBox.append(box);
    }
    function renderResults(data) {
      results.replaceChildren();
      results.append(node('h3', 'l4r__results-heading', labels.matching_heading));
      if (data.status === 'recommendations') {
        data.products.forEach(function (p, i) {
          var card = node('a', 'l4r__card'), rank = node('span', 'l4r__rank', String(i + 1));
          card.href = prefix + 'products/' + encodeURIComponent(p.slug);
          rank.setAttribute('aria-hidden', 'true');
          var body = node('span', 'l4r__card-body');
          var explanation = [p.reason].concat(p.limitations).join(' ');
          body.append(node('span', 'l4r__name', p.name), node('span', 'l4r__blurb', explanation));
          var view = node('span', 'l4r__view', labels.view_product);
          body.append(view); card.append(rank, body); results.append(card);
        });
        announce(labels.results_heading);
      } else {
        var message = node('div', 'l4r__empty', data.message || labels.no_results);
        results.append(message); announce(message.textContent);
      }
      support();
    }
    function validQuestion(question) {
      return answers.length < MAX_ANSWERS && question &&
        typeof question.id === 'string' && typeof question.text === 'string' && question.text.trim() &&
        (!question.help || typeof question.help === 'string') &&
        (!question.options || (Array.isArray(question.options) && question.options.length <= 6 && question.options.every(function (v) { return typeof v === 'string'; })));
    }
    function validResponse(data) {
      if (!data || data.version !== 2 || !Array.isArray(data.products)) return false;
      // Keep compatibility with an older backend during rollout.
      if (data.status === 'question') return data.products.length === 0 && validQuestion(data.question);
      if (data.status === 'no_match') return data.products.length === 0 && typeof data.message === 'string';
      return data.status === 'recommendations' && data.products.length > 0 && data.products.length <= 6 && data.products.every(function (p) {
        return typeof p.name === 'string' && typeof p.slug === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(p.slug) &&
          typeof p.reason === 'string' && p.reason.trim() && Array.isArray(p.limitations) && p.limitations.every(function (v) { return typeof v === 'string'; });
      });
    }
    async function request(data) {
      cancelRequest();
      var requestRevision = revision;
      controller = new AbortController(); var requestController = controller;
      var received = false;
      pendingPayload = data; pending = true;
      // Retain the shortlist for recovery, but hide it while processing a follow-up.
      if (!lastResponse || lastResponse.status !== 'recommendations') clearResults();
      results.querySelectorAll('.l4r__error, .l4r__text-button').forEach(function (el) { el.remove(); });
      renderConversation();
      loading.hidden = false; startLoadingMessages(); root.setAttribute('aria-busy', 'true');
      submit.disabled = true; submit.textContent = labels.searching; announce(labels.checking);
      var timeout = setTimeout(function () { requestController.abort(); }, REQUEST_TIMEOUT);
      try {
        var response = await fetch(API_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data), signal: requestController.signal });
        if (!response.ok) throw new Error('Request failed');
        var next = await response.json();
        if (requestRevision !== revision) return;
        if (!validResponse(next)) throw new Error('Invalid conversation response');
        active = validQuestion(next.question) ? next.question : null; activeDraft = ''; lastResponse = next; received = true;
      } catch (error) {
        if (requestRevision !== revision) return;
        results.append(node('div', 'l4r__error', labels.error));
        if (answers.length) results.append(button('l4r__text-button', labels.retry, function () { request(pendingPayload); }));
        announce(labels.error); support();
      } finally {
        clearTimeout(timeout);
        if (requestRevision === revision) {
          pending = false; controller = null; loading.hidden = true; stopLoadingMessages(); root.removeAttribute('aria-busy');
          submit.disabled = false; submit.textContent = labels.search; renderConversation();
          if (received) {
            if (lastResponse.status !== 'question') renderResults(lastResponse);
            if (active) {
              announce(active.text);
              // Results-first responses do not steal focus/scroll away from the cards.
              if (lastResponse.status === 'question') focusAnswer();
            }
          }
        }
      }
    }
    function saveAnswer(question, value, index) {
      value = value.trim(); if (!value || value.length > 1000) return;
      if (index >= 0 && value === answers[index].answer) {
        editing = -1; renderConversation(); conversation.querySelectorAll('[data-edit-answer]')[index].focus(); return;
      }
      // Remove the dependent suffix before sending anything to the server.
      cancelRequest(); if (index >= 0) answers = answers.slice(0, index);
      answers.push({ question: question, answer: value }); active = null; activeDraft = ''; editing = -1;
      if (index >= 0) clearResults();
      announce(labels.updated); request(payload());
    }
    function cancelEdit(index) {
      editing = -1; renderConversation(); conversation.querySelectorAll('[data-edit-answer]')[index].focus();
    }
    function answerForm(question, value, index) {
      var row = node('form', 'l4r__question');
      if (index >= 0) row.classList.add('l4r__question--editing');
      var hasOptions = question.options && question.options.length;
      if (hasOptions) row.classList.add('l4r__question--choices');
      var id = input.id + '-answer-' + (index < 0 ? answers.length : index);
      var line = node('div', 'l4r__question-line'), promptLabel = node('div', 'l4r__question-prompt');
      var label = node('label', 'l4r__question-label', question.text); label.htmlFor = id;
      promptLabel.append(arrow(), label);
      var controls = node('div', 'l4r__answer-controls');
      var wrap = node('div', 'l4r__answer-wrap'), field = node('textarea', 'l4r__answer');
      field.id = id; field.rows = 1; field.required = true; field.maxLength = 1000; field.autocomplete = 'off';
      field.placeholder = index >= 0 ? '' : labels.other; field.value = value || '';
      var ok = node('button', 'l4r__answer-submit', '\u21a9'); ok.type = 'submit'; ok.disabled = !field.value.trim();
      ok.setAttribute('aria-label', index >= 0 ? labels.update : labels.continue);
      field.addEventListener('input', function () {
        ok.disabled = !field.value.trim(); if (index < 0) activeDraft = field.value; sizeAnswers();
      });
      wrap.append(field, ok);
      if (question.help) {
        var help = node('p', 'l4r__question-help', question.help); help.id = id + '-help';
        field.setAttribute('aria-describedby', help.id); row.append(help);
      }
      if (hasOptions) {
        question.options.forEach(function (option) {
          controls.append(button('l4r__option', option, function () { saveAnswer(question, option, index); }));
        });
      }
      controls.append(wrap); line.append(promptLabel, controls); row.append(line);
      row.addEventListener('submit', function (event) { event.preventDefault(); saveAnswer(question, field.value, index); });
      field.addEventListener('keydown', function (event) {
        if (event.isComposing || event.keyCode === 229) return;
        if (event.key === 'Escape' && index >= 0) { event.preventDefault(); cancelEdit(index); }
        else if (event.key === 'Enter' && !event.shiftKey) { event.preventDefault(); row.requestSubmit(); }
      });
      return row;
    }
    function dim(row) {
      row.classList.add('l4r__dependent'); row.inert = true;
      row.querySelectorAll('button, textarea').forEach(function (el) { el.disabled = true; });
    }
    function renderConversation() {
      conversation.replaceChildren(); refinement.replaceChildren();
      supportBox.hidden = editing >= 0;
      results.hidden = editing >= 0 || (pending && answers.length > 0);
      answers.forEach(function (entry, index) {
        if (editing === index) { conversation.append(answerForm(entry.question, entry.answer, index)); return; }
        var row = node('div', 'l4r__answered');
        var edit = button('l4r__edit', '', function () {
          // Opening an edit is a draft; cancel leaves the existing branch intact.
          cancelRequest(); editing = index; renderConversation();
          if (!active && !lastResponse) {
            results.replaceChildren(button('l4r__text-button', labels.retry, function () { editing = -1; request(payload()); }));
          }
          focusAnswer(true);
        });
        edit.dataset.editAnswer = String(index); edit.setAttribute('aria-label', labels.edit_answer + ': ' + entry.question.text + ' ' + entry.answer);
        edit.setAttribute('aria-expanded', String(editing === index));
        edit.append(arrow(), node('span', 'l4r__answered-label', entry.question.text), node('span', 'l4r__answer-summary', entry.answer));
        row.append(edit); if (editing >= 0 && index > editing) dim(row); conversation.append(row);
      });
      if (active && !pending) {
        refinement.append(node('h3', 'l4r__followup-heading', labels.followup_heading));
        var next = answerForm(active, activeDraft, -1); if (editing >= 0) dim(next); refinement.append(next);
      }
      sizeAnswers();
    }
    form.addEventListener('submit', function (event) {
      event.preventDefault(); var next = input.value.trim(); if (!next || next.length > 1500 || pending) return;
      if (next !== prompt) { answers = []; active = null; activeDraft = ''; }
      prompt = next; editing = -1; clearResults(); request(payload());
    });
    input.addEventListener('input', function () {
      if (prompt && input.value.trim() !== prompt) {
        cancelRequest(); prompt = ''; answers = []; active = null; activeDraft = ''; editing = -1; clearResults(); renderConversation();
      }
      submit.disabled = pending;
    });
    root.addEventListener('finder:destroy', function () { cancelRequest(); clearInterval(promptTimer); sizeObserver.disconnect(); cancelAnimationFrame(resizeFrame); });
  }
  function initAll(scope) { scope.querySelectorAll('[data-product-finder]').forEach(init); }
  initAll(document);
  if (!window.lab401FinderLifecycle) {
    window.lab401FinderLifecycle = true;
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-product-finder]').forEach(function (root) { root.dispatchEvent(new Event('finder:destroy')); });
    });
  }
})();
